import * as React from "react";
import {Paper, Table, TableBody, TableContainer} from "@mui/material";
import LocationRow from "./LocationRow";
import FormattedTableHead from "../FormattedTableHead";
import {ThreeDots} from "@dvrt/graphql-widgets";
import {useDomainLocationStatusQuery} from "./queries.generated";
import {defineMessage} from "react-intl";

type Props = {
    domainId: number;
};

export default function LocationsTable({domainId}: Props) {
    const {data} = useDomainLocationStatusQuery({
        variables: {domainId},
        fetchPolicy: "cache-and-network",
    });

    if (!data) return <ThreeDots height={5} />;

    function createRows(): React.ReactNode[] {
        const rows = [];
        let i = 0;
        for (const location of data.domainStatus.locations) {
            rows.push(<LocationRow key={i} domainId={domainId} location={location} />);
            i++;
        }

        return rows;
    }

    return (
        <TableContainer component={Paper}>
            <Table size="small">
                <FormattedTableHead
                    cells={[
                        {label: defineMessage({id: "number", defaultMessage: "Number"})},
                        {label: defineMessage({id: "ipAddress", defaultMessage: "IP address"})},
                        {label: defineMessage({id: "device_type", defaultMessage: "Device type"})},
                        {label: defineMessage({id: "device_description", defaultMessage: "Device description"})},
                        {
                            label: defineMessage({
                                id: "last_registration_time",
                                defaultMessage: "Last registration time",
                            }),
                        },
                    ]}
                />
                <TableBody>{createRows()}</TableBody>
            </Table>
        </TableContainer>
    );
}
